import { render, staticRenderFns } from "./PredefinedResponses.vue?vue&type=template&id=5f0bf513&scoped=true"
import script from "./PredefinedResponses.vue?vue&type=script&lang=js"
export * from "./PredefinedResponses.vue?vue&type=script&lang=js"
import style0 from "./PredefinedResponses.vue?vue&type=style&index=0&id=5f0bf513&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0bf513",
  null
  
)

export default component.exports